import React from 'react';

import { fmtQty } from '../../format';
import { fmtGap, gapCls, gapPercent, type OpnameTotals } from './opnameDraft';

const Tile: React.FC<{
  label: string;
  testId: string;
  sub?: React.ReactNode;
  children: React.ReactNode;
}> = ({ label, testId, sub, children }) => (
  <div className="rounded-xl bg-bg-weak-50 px-4 py-3" data-testid={testId}>
    <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-text-sub-600">
      {label}
    </p>
    <p className="mt-1.5 text-[24px] font-extrabold leading-none tracking-tight tabular-nums">
      {children}
    </p>
    {sub && <p className="mt-1.5 text-[11px] text-text-sub-600">{sub}</p>}
  </div>
);

/**
 * The count's discrepancy at a glance: the signed total gap (error tone below
 * zero, success above), how many rows differ, and the system vs physical qty.
 * Fed by the draft totals (New page) or by the saved opname (Detail page).
 */
export const DiscrepancySummary: React.FC<{
  totals: OpnameTotals;
  testId?: string;
}> = ({ totals, testId = 'opname-summary' }) => (
  <div
    className="grid grid-cols-2 gap-3 lg:grid-cols-4"
    data-testid={testId}
  >
    <Tile
      label="Total selisih"
      testId={`${testId}-gap`}
      sub="Fisik dikurangi sistem"
    >
      <span className={gapCls(totals.totalGap)}>{fmtGap(totals.totalGap)}</span>
    </Tile>
    <Tile
      label="Baris berselisih"
      testId={`${testId}-lines`}
      sub={`${gapPercent(totals)}% dari ${fmtQty(totals.lineCount)} baris`}
    >
      <span className="text-text-strong-950">
        {fmtQty(totals.gapLineCount)}
      </span>
    </Tile>
    <Tile label="Qty sistem" testId={`${testId}-system`}>
      <span className="text-text-strong-950">
        {fmtQty(totals.totalQtySystem)}
      </span>
    </Tile>
    <Tile label="Qty fisik" testId={`${testId}-physical`}>
      <span className="text-text-strong-950">
        {fmtQty(totals.totalQtyPhysical)}
      </span>
    </Tile>
  </div>
);
